import { styled } from "twin.macro";

const Form = styled.form``;

export default Form;